export default "__VITE_ASSET__Yqw2RWen__"